export enum DataLayerInteractionsEnum {
    AccountNumber = "accountNumber",
    QuestionPremium = "question|premium",
    SortCode = "sortCode",
    BtnSaveBankAddress = "btn|save bank address",
    BankName = "bankname",
    Branch = "branch",
    BankAddress1 = "bankaddress1",
    BankAddress2 = "bankaddress2",
    BankAddress3 = "bankaddress3",
    AddressPostcode = "address.postcode",
    ButtonCancel = "button|cancel",
}
